<script lang="ts" setup>
import { useSchemaOrg, defineWebPage } from '@unhead/schema-org/vue';
import { useSdk } from '~/sdk';

const { locale, t } = useI18n();
const route = useRoute();

const { data, error } = await useAsyncData('page-' + locale.value + '-' + route.params.slug, async () => {
  return useSdk().cms.getContent({
    entry: {
      section: 'sizeCharts',
      slug: route.params.slug,
    },
  });
});

if (!data.value) {
  throw createError({
    statusCode: 404,
    message: t('Page not found'),
  });
}


useSeoMeta({
  title: data.value?.seo?.title,
  description: data.value?.seo?.description,
  ogTitle: data.value?.seo?.title,
  ogDescription: data.value?.seo?.description,
});

useSchemaOrg([
  defineWebPage({
    title: data.value?.seo?.title,
    description: data.value?.seo?.description,
    image: data.value?.seo?.image,
  }),
]);

const components = computed(() => {
  return data.value?.components ?? [];
});

const templates: any = {
  'carousel-block': defineAsyncComponent(() => import('../components/BlockCarousel.vue')),
  'categories-block': defineAsyncComponent(() => import('../components/BlockCategories.vue')),
  // 'text-block': defineAsyncComponent(() => import('../components/BlockText.vue')),
  'products-block': defineAsyncComponent(() => import('../components/BlockProducts.vue')),
  'features-block': defineAsyncComponent(() => import('../components/BlockFeatures.vue')),
  'categoryproducts-block': defineAsyncComponent(() => import('../components/promo/BlockCategoryProducts.vue')),
  'offer-block': defineAsyncComponent(() => import('../components/promo/BlockOffer.vue')),
  'faqs-block': defineAsyncComponent(() => import('../components/promo/BlockFaq.vue')),
  'textimage-block': defineAsyncComponent(() => import('../components/promo/BlockImageText.vue')),
  'text-block': defineAsyncComponent(() => import('../components/promo/BlockText.vue')),
  'cards-block': defineAsyncComponent(() => import('../components/BlockCards.vue')),
};

const isFirstComponent = (component: any) => {
  return components.value && components.value.length > 0 && components.value[0].id === component.id && component.__typename === 'text-block';
};
</script>

<template>
  <div
    class="space-y-16"
    :class="components && components.length > 0 && components[0].__typename == 'carousel-block' ? '' : 'py-16'"
  >
    <div v-for="component in components" :key="component.id" :is="component.__typename">
      <component :is="templates[component.__typename]" v-bind="component" :first="isFirstComponent(component)"></component>
    </div>
  </div>
</template>
